import React, { useState, useEffect } from "react";
import LoginScreen from "./components/LoginScreen";
import UploadPortal from "./components/UploadPortal";

const TOKEN_KEY = "amq_jwt";

function App() {
  const [token, setToken] = useState(null);

  // Restore token from sessionStorage (tab-scoped, cleared on close)
  useEffect(() => {
    const saved = sessionStorage.getItem(TOKEN_KEY);
    if (saved) setToken(saved);
  }, []);

  const handleAuth = (jwt) => {
    sessionStorage.setItem(TOKEN_KEY, jwt);
    setToken(jwt);
  };

  const handleLogout = () => {
    sessionStorage.removeItem(TOKEN_KEY);
    setToken(null);
  };

  // If JWT is expired, the backend will return 401 and
  // UploadPortal calls onLogout to bring the user back here.
  if (!token) {
    return <LoginScreen onAuthenticated={handleAuth} />;
  }

  return <UploadPortal token={token} onLogout={handleLogout} />;
}

export default App;
